import React from 'react'
import {Icon} from '@chakra-ui/react'

const StarHoverIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.9999 1L8.45027 8.73158L0 9.71916L6.2557 15.4841L4.58413 23.8251L12 19.6575L19.4159 23.8251L17.7443 15.4841L24 9.7192L15.5507 8.73158L11.9999 1ZM9.82417 10.6224L12.0002 5.8827L14.1769 10.6224L19.3563 11.2278L15.5216 14.7617L16.5463 19.8752L12 17.3203L7.45371 19.8752L8.47848 14.7617L4.64373 11.2278L9.82417 10.6224Z"
                fill="#D11B59"
            />
        </Icon>
    )
}

export default StarHoverIcon
